import type { ContractObjectData } from 'gql/graphql';

export type TContractObjectData = Omit<ContractObjectData, 'hasGuaranteedVolume'> & { hasGuaranteedVolume: string };
export type TFilters =
    | {
          codeWBS: string;
          hasGuaranteedVolume: string;
      }
    | undefined;

export const getFilteredItems = (items: TContractObjectData[] = [], filters: TFilters) => {
    const withGuaranteed = filters?.hasGuaranteedVolume
        ? items.filter((item) => item.hasGuaranteedVolume === filters.hasGuaranteedVolume)
        : items;

    if (!filters?.codeWBS) {
        return withGuaranteed;
    }

    const itemsMap = new Map(withGuaranteed.map((item) => [item.id, item]));

    const getParentIds = (item: TContractObjectData): number[] => {
        const parents: number[] = [];

        if (item?.parentId) {
            parents.push(item.parentId);
            const nextItem = itemsMap.get(item.parentId);

            if (nextItem) {
                return parents.concat(getParentIds(nextItem));
            }
        }

        return parents;
    };

    const matchingItems = withGuaranteed?.filter(
        (item) => item.codeWBS?.toLowerCase().includes(filters?.codeWBS?.toLowerCase()?.trim() ?? ''),
    );

    const idsToShow = new Set<number>();

    matchingItems?.forEach((item) => {
        idsToShow.add(item.id);
        const ids = getParentIds(item);

        ids.forEach((id) => idsToShow.add(id));
    });

    return withGuaranteed?.filter((item) => idsToShow.has(item.id));
};
